module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei4.svg";